var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inventory_online_mode)?_c('div',[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-lg-10 col-xl-6"},[_c('b-card-group',[_c('TitleInventoryOnline')],1)],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('InventoryTable')],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }